// Microsoft Clarity — nagrywanie sesji i „sygnały frustracji" (rage click,
// dead click, szybki powrót). Darmowe i bez limitu nagrań.
//
// Aktywne TYLKO gdy VUE_APP_CLARITY_ID jest ustawione — ten sam wzorzec co
// Sentry, żeby lokalny dev i buildy bez klucza nic nie wysyłały.
//
// RODO: w panelu widać PESEL-e, numery kont i kwoty wypłat. W panelu Clarity
// MUSI być włączone maskowanie „Strict" (Settings → Masking), a dodatkowo
// oznaczamy wrażliwe miejsca atrybutem data-clarity-mask="true". Clarity nagrywa
// wtedy układ ekranu, nie treść.

let zaladowane = false;

export function initClarity() {
  const id = process.env.VUE_APP_CLARITY_ID;
  if (!id || zaladowane || typeof window === 'undefined') return;
  zaladowane = true;
  // Oficjalny snippet Microsoftu, przepisany czytelnie.
  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
  const tag = document.createElement('script');
  tag.async = true;
  tag.src = 'https://www.clarity.ms/tag/' + id;
  document.head.appendChild(tag);
}

/**
 * Podpięcie nagrania pod konkretne konto — bez tego nie wiadomo, kto trafił na
 * błąd. Przekazujemy WYŁĄCZNIE wewnętrzny identyfikator (UUID), nigdy imienia,
 * e-maila ani telefonu: nagranie zostaje pseudonimowe, a biuro i tak dopasuje
 * je po id w bazie.
 */
export function identifyClarity(id) {
  if (!id || typeof window === 'undefined' || !window.clarity) return;
  try {
    window.clarity('identify', String(id));
  } catch (e) {
    /* Clarity nie może wywrócić aplikacji */
  }
}
